import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { getRepairOrderExistsApi } from 'api/repairOrder';
import { RequestQueryKeysE } from 'declarations/enums/react-query';
import type { ApiErrorI } from 'declarations/interfaces/errors';
import type { RooftopExistsI } from 'declarations/interfaces/roofTopExists';

export const useFetchTicketRoExists = (
  roofTopId: string,
  roNumber: string
): UseQueryResult<RooftopExistsI, ApiErrorI> => {
  return useQuery<RooftopExistsI, ApiErrorI>(
    [RequestQueryKeysE.FetchRepairOrder, roofTopId, roNumber],
    (): Promise<RooftopExistsI> => getRepairOrderExistsApi(roofTopId, roNumber),
    {
      enabled: !!roofTopId && !!roNumber,
    }
  );
};
